import LayoutIcon from "@mui/icons-material/AspectRatio";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import InboxIcon from "@mui/icons-material/Inbox";
import SendIcon from "@mui/icons-material/KeyboardArrowRight";
import FieldsIcon from "@mui/icons-material/Receipt";
import ComponentIcon from "@mui/icons-material/ViewCompact";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import React from "react";
import { Container, Draggable } from "react-smooth-dnd";
import { v4 as uuid } from "uuid";

import { resetMenuField } from "./helper";
import { language } from "../../../language";

const NestedListItem = styled(ListItem)(({ theme }) => ({
  paddingLeft: "8%",
}));

export default function ComponentItem(props) {
  const { item } = props;

  const [open, setOpen] = React.useState({
    layout: true,
    fields: true,
    components: true,
  });

  const handleClick = (name) => {
    const aux = open[name];

    setOpen((prev) => ({
      ...prev,
      [name]: !aux,
    }));
  };

  function getMenuIcon(n) {
    if (n === "fields") return <FieldsIcon />;
    else if (n === "components") return <ComponentIcon />;
    else if (n === "layout") return <LayoutIcon />;
    return <InboxIcon />;
  }

  return (
    <List component="nav" dense sx={{ height: "100%", overflowY: "auto" }}>
      {item &&
        Object.keys(item).map((el, count) => {
          return (
            <div key={`div${el}${count}`}>
              <ListItem
                key={`${el}${count}`}
                button
                onClick={() => handleClick([el])}
              >
                <ListItemIcon>{getMenuIcon(el)}</ListItemIcon>
                <ListItemText primary={language[el]} />
                {open[el] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={open[el]} timeout="auto" unmountOnExit>
                {item[el].map((element, index) => {
                  return (
                    <Container
                      key={`mnitem_${index}`}
                      groupName="1"
                      behaviour="copy"
                      getChildPayload={() => {
                        return {
                          element: { ...resetMenuField(element), uuid: uuid() },
                          openModal: true,
                        };
                      }}
                    >
                      <Draggable key={element}>
                        <NestedListItem button component="div" dense>
                          <ListItemIcon>
                            <SendIcon />
                          </ListItemIcon>
                          <ListItemText primary={element.name} />
                        </NestedListItem>
                      </Draggable>
                    </Container>
                  );
                })}
              </Collapse>
            </div>
          );
        })}
    </List>
  );
}
